export default __webpack_public_path__ + "static/media/survey1.c08a2db4.svg";